<template>
  <div class="">
    <h1 class="title">{{heading}}</h1>
    <div class="table-container">
      <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
        <thead>
          <th class="has-text-centered" v-for="heading in  headings" v-bind:key="heading">{{heading}}</th>
        </thead>
        <tbody>
            <tr v-for="row in tableData" v-bind:key="row.id">
              <td v-for="data in row" v-bind:key="data.id">{{data}}</td>
            </tr>
        </tbody>
      </table>
    </div>
</div>
</template>

<script>
export default {
  props: ['headings', 'tableData', 'heading']
}
</script>

<style lang="scss" scoped>
.title{
  font-family: 'Coda', cursive;
  font-weight: 400;
}
.table thead td, .table thead th{
  color: black;
}
.table thead th{
  font-family: 'Coda', cursive;
  font-weight: bolder;
  text-align: center;
  color: black;
}
.table td, .table th{
  font-family: 'Coda', cursive;
  font-weight: 400;
  text-align: center;
  color: black;
}
 @media screen and (max-width: 1000px){
     .is-responsive{
         width: 100%;
         border-collapse: collapse;
         border-spacing: 0;
         display: block;
         position: relative;
    }
     td:empty:before{
         content: '\00a0';
    }
     th, td{
         margin: 0;
         vertical-align: top;
    }
     th{
         text-align: left;
    }
     thead{
         border-right: solid 2px;
         display: block;
         float: left;
    }
     tr{
         display: block;
         padding: 0 10px 0 0;
    }
     th::before{
         content: "\00a0";
    }
     td, th{
         border-width: 0 0 1px;
    }
     tbody{
         display: block;
         width: auto;
         position: relative;
         overflow-x: auto;
         white-space: nowrap;
    }
     tr{
         display: inline-block;
         vertical-align: top;
    }
     th{
         display: block;
         text-align: right;
    }
     td{
         display: block;
         min-height: 1.25em;
         text-align: left;
    }
     th, td &:last-child{
         border-bottom-width: 0;
    }
     tr &:last-child td:not(:last-child){
         //border: $table-cell-border;
         // border-width: $table-cell-border-width;
    }
     &.is-bordered td, th{
         border-width: 1px;
    }
     tr td, th &:last-child{
         border-bottom-width: 1px;
    }
     &:last-child td, th{
         border-width: 1px;
    }
}
</style>



// WEBPACK FOOTER //
// rtable.vue?9bc67634